import React, { Component } from 'react'
import { translate } from '../../utils/useful'

export default class MeetingsReady extends Component {
    state = {
        isCopied: false,
    }
    render() {
        return (
            <div className='w-100 px-3 py-4 br-10 box-shadow-widgets'>
                <div className='flexcb w-100'>
                    <p className='text-normal'>{translate(`Your meetings ready`)}</p>
                    <img height='15px' src="/images/close.png" alt="" />
                </div>
                <div className='mt-3'>
                    <button className='flexc bg-blue px-3 py-2 br-10 text-white'>
                        <img className='mrd-3 invert' height='15px' src="/images/add-user-g.png" alt="" />
                        <p>{translate(`Add others`)}</p>
                    </button>
                </div>
                <div className='mt-2'>
                    <p className='text-small color-gray-4'>Or share this meeting link with other that you want in the meeting </p>
                </div>
                <div className='br-10 mt-2 bg-gray-5 flexcb w-100 px-4 py-3'>
                    <div className=''>
                        <p className='color-muted text-small'>meet.elitive.com/dsanb-123eg</p>
                    </div>
                    <div>
                        <img height='25px' className='cursor-pointer transition-all copy-hover' src="/images/copy.png" alt="" />
                    </div>
                </div>
                <div className='mt-2 flexc px-2'>
                    <div className='mrd-3'>
                        <img height='20px' src="/images/shield.png" alt="" />
                    </div>
                    <div>
                        <p className='text-small color-gray-3'>People who use this meeting link must get your permission before they can join.</p>
                    </div>
                </div>
                <div className='mt-3'>
                    <p className='color-gray-3 text-small'>Joined as Sefid.Moeshedi@gmail.com</p>
                </div>
            </div>
        )
    }
}
